module.exports = __webpack_public_path__ + "img/case_2.8b6d5ff0.png";